(function () {
/*
 * -----------------------------------------------------------------------------
 * @cam/input-number-parser
 * -----------------------------------------------------------------------------
 * @version 0.0.1
 * @overview Prevents non-number input in "number" type input fields.
 * @copyright 2021 Cam Gould & Elkfox Co Pty Ltd - All rights reserved
 * -----------------------------------------------------------------------------
*/ if (customElements.get("input-number-parser") === undefined) {
    class InputNumberParser extends HTMLElement {
        constructor(){
            super();
            this.style.display = "contents";
            this.input = this.querySelector("input");
            if (!this.input) return;
            this.lastValidInput = this.input.value;
            this.input.addEventListener("input", this.debounce(this.updateEvent.bind(this), 100), false);
        }
        debounce(callback, timeout) {
            let timer;
            return (...args)=>{
                clearTimeout(timer);
                timer = setTimeout(()=>callback.apply(this, args), timeout);
            };
        }
        updateEvent() {
            if (this.input.value !== "") this.lastValidInput = this.input.value;
            else {
                this.input.value = this.lastValidInput;
                this.input.dispatchEvent(new Event("input"));
            }
        }
    }
    customElements.define("input-number-parser", InputNumberParser);
}



})();
